import { BREAKPOINTS } from '@repo/ui/queries';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 33px 24px;

  background: center url('/images/bgSignUp.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;

  display: none;
  @media (min-width: ${BREAKPOINTS.largeTabletMin}px) {
    display: flex;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  padding: 42px 16px 24px 16px;
`;

export const Benefit = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;

export const BackgroundImage = styled.img<{ fullWidth: boolean }>`
  width: 100%;

  position: ${({ fullWidth }) => (fullWidth ? 'absolute' : 'unset')};
  bottom: 0;
  left: 0;
`;
